const attendance_calculatedMetrics = {
  AdmissionPerCap: {
    numerator: 'AdmissionRevenues',
    denominator: 'Attendance',
  },
  BudgetAdmissionPerCap: {
    numerator: 'BudgetAdmissionRevenues',
    denominator: 'BudgetAttendance',
  },
};

const attendance_metrics = {
  Attendance: {
    fieldName: 'Attendance',
    displayName: 'Attendance',
    chartFormat: ',',
    format: {
      style: 'decimal',
      maximumFractionDigits: 0,
    },
  },
  AdmissionPerCap: {
    fieldName: 'AdmissionPerCap',
    displayName: 'Admission Per Cap',
    chartFormat: '$.2f',
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      // minimumFractionDigits: 2,
    },
  },
  AdmissionRevenues: {
    fieldName: 'AdmissionRevenues',
    displayName: 'Admisssion Revenues',
    chartFormat: '$~s',
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
      // maximumSignificantDigits: 3,
    },
  },
  BudgetAttendance: {
    fieldName: 'BudgetAttendance',
    displayName: 'Budget Attendance',
    chartFormat: ',',
    format: {
      style: 'decimal',
      maximumFractionDigits: 0,
    },
  },
  BudgetAdmissionPerCap: {
    fieldName: 'BudgetAdmissionPerCap',
    displayName: 'Budget Admission Per Cap',
    chartFormat: '$.2f',
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      // minimumFractionDigits: 2,
    },
  },
  BudgetAdmissionRevenues: {
    fieldName: 'BudgetAdmissionRevenues',
    displayName: 'Budget Admisssion Revenues',
    chartFormat: '$~s',
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
      // maximumSignificantDigits: 3,
    },
  },
};

const attendance_filterDimensions = {
  Park: {
    order: 'asc',
    customOrder: ['SWF', 'APO', 'BGT', 'AIT', 'SWC', 'SPC', 'SWT', 'APT', 'BGW', 'WCW', 'SPL'],
  },
  Date: {
    // order: 'desc',
    sortType: 'alpha',
  },
  Year: {
    // order: 'desc',// Gets overridden by the getFilterValues special case
    sortType: 'alpha',
  },
  YearMonth: {
    // order: 'desc',// Gets overridden by the getFilterValues special case
    sortType: 'alpha',
  },
  ProductCategory: {
    order: 'desc',
    customOrder: ['Discrete', 'Pass', 'Free'],
  },
  ProductType: {
    order: 'desc',
    customOrder: ['SDT', 'MDT', 'FC', 'Fun Card', 'Pass', 'Free'],
  },
  WeatherCode: {
    // order: 'desc',// Gets overridden by the getFilterValues special case
    sortType: 'alpha',
  },
};

export default { attendance_calculatedMetrics, attendance_metrics, attendance_filterDimensions };
